import FnrCard from "UI/FnrCard/FnrCard";
import FnrLabeledIcon from "UI/FnrLabeledIcon/FnrLabeledIcon";
import FnrOptionCardsContainer from "./FnrOptionCardsContainer";
import PropTypes from "prop-types";

const FnrOptionCards = ({ options = [], onSelect }) => (
  <FnrOptionCardsContainer>
    {options.map((optionData) => {
      const { icon, label, testId, id } = optionData;
      return (
        <FnrCard onClick={() => onSelect(optionData)} key={id} data-cy={testId}>
          <FnrLabeledIcon variant="leftColumn" icon={icon}>
            {label}
          </FnrLabeledIcon>
        </FnrCard>
      );
    })}
  </FnrOptionCardsContainer>
);

FnrOptionCards.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      testId: PropTypes.string,
    })
  ),
  onSelect: PropTypes.func.isRequired,
};

export default FnrOptionCards;
